import { createContentDocument } from './document.mjs';

/** Layout only: all non-heading source lines stay verbatim. This never invents a lesson. */
export function arrangeSourceText({ topic, sourceText, templateId }) {
  if (typeof sourceText !== 'string' || !sourceText.trim()) throw new Error('구성할 원문을 먼저 넣어 주세요.');
  const document = createContentDocument(templateId);
  document.title = (topic ?? '').trim();
  let current = { id: 'section-1', kind: 'text', title: '', body: '' };
  const flush = () => { if (current.title || current.body) document.sections.push(current); };
  for (const line of sourceText.match(/[^\n]*(?:\n|$)/g)) {
    if (!line) continue;
    const heading = /^(#{1,3})[^\S\r\n]+(.+?)(?:\r?\n)?$/.exec(line);
    if (heading) {
      if (heading[1] === '#' && !document.title && !document.sections.length && !current.body) { document.title = heading[2]; continue; }
      flush();
      current = { id: `section-${document.sections.length + 1}`, kind: 'text', title: heading[2], body: '' };
    } else { current.body += line; }
  }
  flush();
  return document;
}
